var $body;
var $window;
var $notifications;
var href_encoded = location.href;
var gmap_ready = false;
var htmlCanvas = null;
var gl = null;

var itemQueue = [];
var waypointsdelay = 100;
var queueTimer = null;
var KEYCODE_ESC = 27;

$(document).keyup(function (e) {
	"use strict";
	
	if (e.keyCode === KEYCODE_ESC) {
		if (!$('body').hasClass('project-open')) {
			$('body').css('overflow', 'auto');
		}
		if ($('body').hasClass('popup-open')) {
			if (!$('body').hasClass('project-open')) {
				$('body').css('overflow', 'auto');
			}
			$('footer .share-this-section').removeClass('tsh-popup');
			$('footer .tsh-share-this').removeClass('tsh-share-this-show');
			$('body').removeClass('popup-open');
			$('header').fadeIn(500);

		}
		$('footer .contact-section').removeClass('tsh-popup');
		$('footer .tsh-contact-us').removeClass('tsh-contact-us-show');
		$('body').removeClass('popup-open');
		$('header').fadeIn(500);

		$('.contact-us-tabs-btns .open-tab input').removeAttr('checked');
		$('#contact-form .hs-input').each(function () {
			$(this).removeAttr('checked');
		});
		$('#contact-form .general-input').each(function () {
			$(this).val('');
		});
		$('#contact-form textarea').val('');
		$('.contact-us-tabs-btns .open-tab').removeClass('open-tab');
		$('.tab-hire.show-tab').removeClass('show-tab');
		$('.tab-general.show-tab').removeClass('show-tab');

		/*CLOSE NAVIGATION*/
		if ($('body').hasClass('navigation-is-open')) {
			$('body').css('overflow', 'auto');
			$('body').removeClass('navigation-is-open');
			$(".navi-trigger.cross").removeClass("cross");
		}

	}
});

$(window).load(function () {
	"use strict";

	$body = $('body');
	$window = $(window);
	
	updateImagesSrc();
	
	setTimeout(function () {
		$('#content_wrapper').removeClass("loading");
		$('#content_wrapper').addClass('loaded');
		$('#content_wrapper #main_wrapper').animate({
			opacity: 1
		}, 300);
		
		if (!$('body').hasClass('section-home')){
			$('body').css('overflow', 'auto');
		}
		set_heights();
		
	
		if ($('body').hasClass('section-home')){
			
			$('.home-navigation-dots').css('width', ($('.weather').width())+'px');
			
			$('.home-slider').on('init', function(event, slick){
			    
				if(!$('.html-5-video').hasClass('text-fill')){
					$('.slick-current .html-5-video').get(0).play();
				}
				
			}).slick({
				infinite: false,
				dots: true,
				appendDots: $('.home-navigation-dots'),
				arrows:true,
				appendArrows: $('.home-navigation-dots'),
				prevArrow: '<span class="slick-arrow prev"><svg width="18px" height="17px" viewBox="0 0 18 17" version="1.1" xmlns="http://www.w3.org/2000/svg"><g id="prev" transform="translate(8.500000, 8.500000) scale(-1, 1) translate(-8.500000, -8.500000)"><polygon class="arrow" points="16.3746667 8.33860465 7.76133333 15.3067621 6.904 14.3175671 14.2906667 8.34246869 6.908 2.42790698 7.76 1.43613596"></polygon><polygon class="arrow-fixed" points="16.3746667 8.33860465 7.76133333 15.3067621 6.904 14.3175671 14.2906667 8.34246869 6.908 2.42790698 7.76 1.43613596"></polygon><path d="M-1.48029737e-15,0.56157424 L-1.48029737e-15,16.1929159 L9.708,8.33860465 L-2.66453526e-15,0.56157424 L-1.48029737e-15,0.56157424 Z M1.33333333,3.30246869 L7.62533333,8.34246869 L1.33333333,13.4327013 L1.33333333,3.30246869 L1.33333333,3.30246869 Z"></path></g></svg></span>',
				nextArrow: '<span class="slick-arrow next" ><svg width="18px" height="17px" viewBox="-1 0 18 17" version="1.1" xmlns="http://www.w3.org/2000/svg"><g><polygon class="arrow" points="16.3746667 8.33860465 7.76133333 15.3067621 6.904 14.3175671 14.2906667 8.34246869 6.908 2.42790698 7.76 1.43613596"></polygon><polygon class="arrow-fixed" points="16.3746667 8.33860465 7.76133333 15.3067621 6.904 14.3175671 14.2906667 8.34246869 6.908 2.42790698 7.76 1.43613596"></polygon><path d="M-4.58892184e-16,0.56157424 L-4.58892184e-16,16.1929159 L9.708,8.33860465 L-1.64313008e-15,0.56157424 L-4.58892184e-16,0.56157424 Z M1.33333333,3.30246869 L7.62533333,8.34246869 L1.33333333,13.4327013 L1.33333333,3.30246869 L1.33333333,3.30246869 Z"></path></g></svg></span>'
			});
						
			$('.home-slider').on('afterChange', function(){
			    if(!$('.html-5-video').hasClass('text-fill')){ 
					$('.html-5-video').each(function(){ 
						$(this).get(0).pause(); 
					}); 
				}
				if(!$('.slick-current .html-5-video').hasClass('text-fill')){ 
					$('.slick-current .html-5-video').get(0).play(); 
				}
			}); 
			
			var stopScrollfixMac = false;
    		var scrollSumPositive = 0;
    		var scrollSumNegative = 0;
			$(document).on("mousewheel", function (event) {
				
				if ($('body').hasClass('popup-open')){
					return;
				}
				
				if (event.originalEvent.wheelDelta < 0) {
					scrollSumPositive = +event.originalEvent.wheelDelta;
				} else {
					scrollSumNegative = +event.originalEvent.wheelDelta;
				}
				if (scrollSumPositive <= -120 || scrollSumNegative >= 120) {
					scrollSumPositive = 0;
					scrollSumNegative = 0;
					stopScrollfixMac = false;
				} else {
					stopScrollfixMac = true;
				}

				if (stopScrollfixMac) {
					event.preventDefault();
					event.stopPropagation();
				}

				if (event.deltaX > 0 || event.deltaY < 0) {
					$(".home-slider").slick('slickNext');
				} else if (event.deltaX < 0 || event.deltaY > 0) {
					$(".home-slider").slick('slickPrev');
				}
				return false;
			});
		}
		
		if ($('body').hasClass('section-clients')){
		
			$('.testimonial-slider').slick({
				dots: true,
				infinite:true,
				adaptiveHeight: true,
				arrows:false,
				autoplay:true,
  				autoplaySpeed:8000,
				responsive: [
				{
					breakpoint: 767,
					settings: {
						dots: false
		  			}
				}]
			});			
		}
		
		if ($('body').hasClass('section-dmr-landing')){
		
			$('.clients-slider').slick({
				slidesToShow: 5,
				slidesToScroll: 1,
				autoplay: true,
				autoplaySpeed: 0,
				arrows: false,
				dots: false,
				speed: 6000,
				pauseOnHover: false,
				pauseOnFocus: false,
				cssEase: 'linear',
				responsive: [{
					breakpoint: 1500,
					settings: {
						slidesToShow: 4
					}
				},{
					breakpoint: 1200,
					settings: {
						slidesToShow: 3
					}
				}, {
					breakpoint: 900,
					settings: {
						slidesToShow: 3
					}
				}, {
					breakpoint: 767,
					settings: {
						slidesToShow: 2
					}
				}]
			});			
		}

		if ($('body').hasClass('section-blog') || $('body').hasClass('section-projects') || $('body').hasClass('section-what-weve-done')){

			$('.subhead').addClass('fixed');
			$('.scroll-down').css('display', 'none');
			
			vp_init('.player');
			/*as_init('.projects-album-slider');*/

			$('.no-touch .grid__item:visible').each(function () {
				var $element = $(this);
				$element.waypoint(
					function (direction) {
						if (direction === "down") {
							itemQueue.push(this.element);
							processWaypointsQueue();
						} 
					}, {
						offset: function () {
							return $(window).height() - this.element.clientHeight / 3;
						}
					}
				);

				$element.waypoint(
					function (direction) {
						if (direction === "up") {
							$(this.element).removeClass("slideUp").addClass("fadeOut");
						}
					}, {
						offset: function () {
							return $(window).height() - this.element.clientHeight / 3;
						}
					}
				);

			});			

		}

		if (!$('body').hasClass('section-home') && !$('body').hasClass('section-what-weve-done')){
			$("*[class*='edge--']").waypoint({
				handler: function (direction) {
					if (direction === 'up') {
						$(this.element).removeClass('reduced');						
					} else if (direction === 'down') {
						$(this.element).addClass('reduced');						
					}
				},
				offset: '80%'
			});
		
			$("*[class*='content-block']").not(".skip-animation").waypoint({
				handler: function (direction) {
					if (direction === 'up') {
						$(this.element).removeClass('inview');
					} else if (direction === 'down') {
						$(this.element).addClass('inview');
					}
				},
				offset: '80%'
			});



			 
			Waypoint.refreshAll();
		}
		
	}, 200);	
});

$(window).resize(function () {
	"use strict";
	updateImagesSrc();
	setTimeout(function () {
		set_heights();
		updateBlogSidebar();
		Waypoint.refreshAll();
	}, 200);
});

$(function () {
	"use strict";

	$body = $('body');
	$window = $(window);
	$notifications = $('.notifications');

    if(window.location.hash.substr(0,16) == '#!/our-thoughts/'){
        window.location = URL +'blog/' + window.location.hash.replace('#!/our-thoughts/','') +'/';
    }
		
	$('.contact-us-tabs-btns label').click(function () {
		var tab = $(this).data('tab');

		if (!$(this).hasClass('open-tab')) {
			$('#contact-form .hs-input').each(function () {
				$(this).removeAttr('checked');
			});
			$('.contact-us-tabs-btns label.open-tab').removeClass('open-tab');
			$(this).addClass('open-tab');

			if (tab === 'why_you_came_hire') {
				$('.tab-hire').addClass('show-tab');
			} else {
				$('.tab-hire.show-tab').removeClass('show-tab');
			}
			$('.tab-general').addClass('show-tab');
			if($('html').hasClass('touch')){
				setTimeout(function(){
					var offset = $('.tsh-contact-us-form-container .hello').innerHeight() + $('.tsh-contact-us-form-container .offset_block').innerHeight() +50 ;
					console.log(offset);
					$(".tsh-contact-us").animate({ scrollTop: offset  }, 500);					
				},600);				
			}
			
		}
	});

	var isLateralNavAnimating = false;
	$(document).on('click', '.navi-trigger', function (e) {
		e.preventDefault();
		if (!isLateralNavAnimating) {
			if ($('body').hasClass('navigation-is-open')) {
				$('body').css('overflow', 'auto');
			} else {
				$('body').css('overflow', 'hidden');
			}
			$('body').toggleClass('navigation-is-open');
			$(".navi-trigger").toggleClass("cross");
		}
	});

	$(document).on('click', '.album-selector', function () {
		var href = $(this).attr('href');
		var openStrategy = $(this).hasClass('show-strategy');

		$('.album-selector').each(function () {
			$(this).removeClass('activated');
		});

		$(this).addClass('activated');

		$('.album').animate({
			opacity: 0
		}, 500, function () {
			if (openStrategy) {
				var startegyContent = $('.project-strategy:hidden').clone(true).show();
				$('.album').html(startegyContent).animate({
					opacity: 1
				}, 500, function () {});
			} else {
				$('.album').load(href, function () {
					$(this).animate({
						opacity: 1
					}, 500, function () {});
				});
			}
		});
		return false;
	});

	$(document).on('click', '.filters .filter', function (e) {
		var value = $(this).data('filterValue');
		var label = $(this).text();

		/*$('.filter-label').html(label).fadeIn(500);*/
		$('.filter-reset').fadeIn(500);

		filter(value);
		$('.popover').fadeOut(500);
		scroll2element('body', -5);
		e.preventDefault();
	});

	$(document).on('click', '.filter-reset', function (e) {
		$('.filter-reset').fadeOut(500);
		/*$('.filter-label').fadeOut(500);*/
		filter(0);
		scroll2element('body', -5);
		e.preventDefault();
	});

	$(document).on('click', '.contact-us, .get-in-touch, .close-contact', function () {

		if ($('body').hasClass('popup-open')) {

			if (!$('body').hasClass('project-open')) {
				$('body').css('overflow', 'auto');
			}
			$('footer .contact-section').removeClass('tsh-popup');
			$('footer .tsh-contact-us').removeClass('tsh-contact-us-show');
			$('body').removeClass('popup-open');
			$('header').fadeIn(500);

			$('.contact-us-tabs-btns .open-tab input').removeAttr('checked');
			$('#contact-form .hs-input').each(function () {
				$(this).removeAttr('checked');
			});
			$('#contact-form .general-input').each(function () {
				$(this).val('');
			});
			$('#contact-form textarea').val('');
			$('.contact-us-tabs-btns .open-tab').removeClass('open-tab');
			$('.tab-hire.show-tab').removeClass('show-tab');
			$('.tab-general.show-tab').removeClass('show-tab');

		} else {

			$('header').fadeOut(500);
			$('body').addClass('popup-open');
			$('footer .contact-section').addClass('tsh-popup');
			$('footer .tsh-contact-us').addClass('tsh-contact-us-show');
			$('body').css('overflow', 'hidden');

		}
		return false;
	});

	$(document).on('click', '.share-open, .close-share-this', function () {

		if ($('body').hasClass('popup-open')) {

			if (!$('body').hasClass('project-open')) {
				$('body').css('overflow', 'auto');
			}
			$('footer .share-this-section').removeClass('tsh-popup');
			$('footer .tsh-share-this').removeClass('tsh-share-this-show');
			$('body').removeClass('popup-open');
			$('header').fadeIn(500);

		} else {

			$('.tsh-share-this-form-container #share-title').html($('.data_holder').data('socialTitle'));
			$('.tsh-share-this-form-container #share-caption').html($('.data_holder').data('socialCaption'));

			$('.tsh-share-this-form-container #clipboard_text').attr('value', $('.data_holder').data('socialUrl'));
			var encodedURL = encodeURIComponent($('.data_holder').data('socialUrl')).replace(/!/g, '%21')
				.replace(/'/g, '%27')
				.replace(/\(/g, '%28')
				.replace(/\)/g, '%29')
				.replace(/\*/g, '%2A')
				.replace(/%20/g, '+');

			$('.tsh-share-this-form-container #share-image').html('<img src="' + $('.data_holder').data('socialImg') + '" class="img-responsive center-block" alt="' + $('.data_holder').data('socialTitle') + '" title="' + $('.data_holder').data('socialTitle') + '" />');

			$('.tsh-share-this-form-container .fb_link').attr('href','https://www.facebook.com/dialog/feed?app_id=' + FACEBOOK_APP_ID + '&link=' + encodedURL );
			
			$('.tsh-share-this-form-container .tw_link').attr('href', 'https://twitter.com/intent/tweet?text=' + encodedURL );
			$('.tsh-share-this-form-container .li_link').attr('href', 'https://www.linkedin.com/shareArticle?mini=true&url=' + encodedURL );
			$('.tsh-share-this-form-container .gp_link').attr('href', 'https://plus.google.com/share?url=' + encodedURL); 
			$('.tsh-share-this-form-container .mail_link').attr('href', 'mailto:?subject=The Smiling Hippo :: ' + $('.data_holder').data('socialTitle') + '&body=' + encodedURL);

			$('header').fadeOut(500);
			$('body').addClass('popup-open');
			$('footer .share-this-section').addClass('tsh-popup');
			$('footer .tsh-share-this').addClass('tsh-share-this-show');
			$('body').css('overflow', 'hidden');

		}
		return false;
	});

	$(document).on("click", '.more-results', function () {
		if ($(this).attr('rel')) {
			more($(this).attr('rel'), $(this));
		}
		return false;
	});

	$(document).on('click', '.scroll-down', function () {
		scroll2element('#pagecontent', -85);
		return false;
	});

	$(document).on('click', '.scroll-top', function () {
		scroll2element('body', -85);
		return false;
	});

	$(document).on('scroll', function () {
		onScroll(-$(this).scrollTop());

		if ($('body').hasClass('section-what-we-do')){

			var timelineBlocks = $('.cd-timeline-block');
			var offset = 0.8;
			hideBlocks(timelineBlocks);
			if (!window.requestAnimationFrame) {
				setTimeout(function () {
					showBlocks(timelineBlocks, offset);
				}, 300);
			} else {
				window.requestAnimationFrame(function () {
					showBlocks(timelineBlocks, offset);
				});
			}
		}
	});		
	
});

function vp_init(mediaholder){
	'use strict';
	$(mediaholder).mediaelementplayer({
		success: function(mediaElement, originalNode, instance) {
			// do things
		}
	});
}

function as_init(albumholder){
	'use strict';
	
	$(albumholder).slick({
		mobileFirst: true,
		adaptiveHeight: true,
		arrows:false	
	});		
}
function getScrollY() {
	"use strict";
	return window.pageYOffset || window.document.documentElement.scrollTop;
}

function scroll2element(el, offset) {
	"use strict";
	var position = $(el).offset();
	var o = offset || 0;
	$('html, body').stop().animate({
		scrollTop: position.top + o
	}, 1000);

}

function onScroll(curTop) {
	"use strict";

	var threshold = 0;
	if ($('body').hasClass('section-blog') || $('body').hasClass('section-projects') || $('body').hasClass('section-what-weve-done')) {
		threshold = 150;
	} else {
		threshold = 50;
	}

	if (curTop < 0) {
		curTop = curTop * -1;
	}

	updateBlogSidebar();

	if ($('body').hasClass('section-blog') || $('body').hasClass('section-projects') || $('body').hasClass('section-what-weve-done')) {

		$('.subhead').addClass('fixed');
		$('.scroll-down').removeClass('visible');
		
		if (curTop >= threshold && $('.gotowork').css('display')==='none') {
			$('.gotowork').css('display', 'block');
		}
		else if (curTop < threshold && $('.gotowork').css('display')==='block') {
			$('.gotowork').css('display', 'none');
		}

	} else {

		if (curTop >= threshold && !$('.subhead').hasClass('fixed')) {
			$('.subhead').addClass('fixed').css('margin-top', '-100px').animate({
				'margin-top': '0px'
			}, 300);
			$('.scroll-down').removeClass('visible');
		} else if (curTop >= threshold && !$('.subhead').hasClass('fixed')) {

		} else if (curTop < threshold && $('.subhead').hasClass('fixed')) {
			$('.subhead').removeClass('fixed').animate({
				'margin-top': '0'
			}, 300);
			$('.scroll-down').addClass('visible');
		}
	}
}

function updateBlogSidebar(){
	
	"use strict";
	if ($('html').hasClass('no-touch') && $('body').hasClass('section-blog') && $('.summary').hasClass('noajax')){
		var $el = $('.right-side');
		var elementWidth = $('.container').innerWidth() - $('.left-side').innerWidth();
		var elementPosition = $('.left-side').offset().left+ $('.left-side').innerWidth();
		var fixthreshold = $('.summary.noajax').offset().top - $(window).scrollTop();
		if(fixthreshold <= 60 ){
			$el.css('max-width',elementWidth).css('position','fixed').css('left',elementPosition).css('top','124px');
		} else if(fixthreshold > 60 && $el.css('position') === 'fixed'){
			$el.css('max-width','').css('position','').css('left','').css('top','');
		}    
	}
}

function updateImagesSrc() {
	"use strict";
	if ($(window).innerWidth() <= 600) {
		$('.adaptive-image').each(function () {
			var _this_image = $(this);
			_this_image.attr('src', _this_image.data('src-mobile'));
		});
	} else {
		$('.adaptive-image').each(function () {
			var _this_image = $(this);
			_this_image.attr('src', _this_image.data('src'));
		});
	}
}

function hideBlocks(blocks) {
	"use strict";
	blocks.each(function () {
		$(this).find('.cd-timeline-img, .cd-timeline-content').addClass('is-hidden');
	});
}

function showBlocks(blocks, offset) {
	"use strict";
	blocks.each(function () {
		if ($(this).offset().top <= ($(window).scrollTop() + $(window).height() * offset) && $(this).find('.cd-timeline-img').hasClass('is-hidden')) {
			$(this).find('.cd-timeline-img, .cd-timeline-content').removeClass('is-hidden').addClass('bounce-in');
		}
	});
}

function processWaypointsQueue() {
	"use strict";
	if (queueTimer) {
		return;
	}

	queueTimer = window.setInterval(function () {
		if (itemQueue.length) {
			$(itemQueue.shift()).addClass('slideUp').removeClass('fadeOut');
			processWaypointsQueue();
		} else {
			window.clearInterval(queueTimer);
			queueTimer = null;
		}
	}, waypointsdelay);

	Waypoint.refreshAll();
}


function deleteRenderTarget(rt) {
	"use strict";
	gl.deleteFramebuffer(rt.frameBuffer);
	gl.deleteRenderbuffer(rt.renderBuffer);
}

function createRenderTarget(w, h) {
	"use strict";
	var ret = {
		'width': w,
		'height': h,
		'sizeArray': new Float32Array([w, h, w / h]),
		'dtxArray': new Float32Array([1.0 / w, 1.0 / h])
	};

	ret.renderBuffer = gl.createRenderbuffer();
	ret.frameBuffer = gl.createFramebuffer();

	gl.bindFramebuffer(gl.FRAMEBUFFER, ret.frameBuffer);
	gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, ret.texture, 0);

	gl.bindRenderbuffer(gl.RENDERBUFFER, ret.renderBuffer);
	gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_COMPONENT16, w, h);
	gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_ATTACHMENT, gl.RENDERBUFFER, ret.renderBuffer);

	gl.bindRenderbuffer(gl.RENDERBUFFER, null);
	gl.bindFramebuffer(gl.FRAMEBUFFER, null);

	return ret;
}

var renderSpec = {
	'width': 0,
	'height': 0,
	'aspect': 1,
	'array': new Float32Array(3),
	'halfWidth': 0,
	'halfHeight': 0,
	'halfArray': new Float32Array(3)		
};
renderSpec.setSize = function (w, h) {
	"use strict";
	renderSpec.width = w;
	renderSpec.height = h;
	renderSpec.aspect = renderSpec.width / renderSpec.height;
	renderSpec.array[0] = renderSpec.width;
	renderSpec.array[1] = renderSpec.height;
	renderSpec.array[2] = renderSpec.aspect;

	renderSpec.halfWidth = Math.floor(w / 2);
	renderSpec.halfHeight = Math.floor(h / 2);
	renderSpec.halfArray[0] = renderSpec.halfWidth;
	renderSpec.halfArray[1] = renderSpec.halfHeight;
	renderSpec.halfArray[2] = renderSpec.halfWidth / renderSpec.halfHeight;
};
function resizeCanvas(gl, canvas, w, h) {
	"use strict";
	
	canvas.width = w;
	canvas.height = h;
	
	renderSpec.setSize(w, h);
	gl.clearColor(0, 0, 0, 0);
	gl.viewport(0, 0, renderSpec.width, renderSpec.height);

	var rtfunc = function (rtname, rtw, rth) {
		var rt = renderSpec[rtname];
		if (rt) {
			deleteRenderTarget(rt);
		}
		renderSpec[rtname] = createRenderTarget(rtw, rth);
	};
	rtfunc('mainRT', renderSpec.width, renderSpec.height);
	rtfunc('wFullRT0', renderSpec.width, renderSpec.height);
	rtfunc('wFullRT1', renderSpec.width, renderSpec.height);
	rtfunc('wHalfRT0', renderSpec.halfWidth, renderSpec.halfHeight);
	rtfunc('wHalfRT1', renderSpec.halfWidth, renderSpec.halfHeight);	
}

function set_heights() {
	"use strict";

	if ($('#content_wrapper').hasClass('loaded')) {
		var ratio = 16 / 10;
		var widthAdjust = $window.innerWidth();
		var heightAdjust = $window.innerHeight();
		var windowRatio = $window.innerWidth() / $window.innerHeight();
		if ($('.intro').hasClass('maskedhero')) {
			console.log(heightAdjust);
			var shape = document.getElementById("svg-defs");
			shape.setAttribute("viewBox", "0 0 " + widthAdjust + " " + heightAdjust);
			console.log(shape);

			var mask = document.getElementById("svg-inverted-mask");
			mask.setAttribute("viewBox", "0 0 " + widthAdjust + " " + heightAdjust);
			console.log(mask);

			$('.box-with-text').hide().show(0);
			$('.intro .content-block').css('min-height', heightAdjust);
			if (windowRatio >= ratio) {
				$('.intro .content-block .html-5-video').css('width', widthAdjust).css('height', 'auto');
			} else {
				$('.intro .content-block .html-5-video').css('height', heightAdjust).css('width', 'auto');
			}
		}

		if ($('.intro').hasClass('weatherhero') || $('.intro').hasClass('projecthero')) {
			
			$('.scroll-down').css('display', 'none');
			$('.home-navigation-dots').css('width', ($('.weather').width())+'px');
			
			if (windowRatio >= ratio) {
				$('.weatherdata').css('height', $window.innerHeight());
				$('.intro').css('min-height', $window.innerHeight());
				$('.intro .html-5-video').css('width', 'auto').css('height', 'auto');
				
			} else {
				$('.weatherdata').css('height', heightAdjust);
				$('.intro').css('min-height', heightAdjust);
				$('.intro .html-5-video').css('height', heightAdjust).css('width', 'auto');
			}

			htmlCanvas = document.getElementById("container");
			gl = htmlCanvas.getContext('experimental-webgl');
			try {
				resizeCanvas(gl, htmlCanvas, widthAdjust, heightAdjust);
			} catch (e) {
				console.error(e);
				return;
			}
		}

		if ($('body').hasClass('project-open')) {
			var popupPosition = getScrollY() - $('.grid').offset().top;
			var addon = 0;
			
			if(!$('body').hasClass('section-blog') && windowRatio <= 1 ){ addon = 60; }
			$('.content.content--show').css('top', (popupPosition+addon) + 'px');
			
			$('.placeholder').css({
				'transform': 'translate3d(-5px, ' + (popupPosition) + 'px, 0px)',
				'-webkit-transform': 'translate3d(-5px, ' + (popupPosition) + 'px, 0px)'
			});
		}
	}
}


function filter(target) {
	"use strict";
	
	Waypoint.destroyAll();
	var typestring;
	
	if (target === 0) {
		$('.projects-list .grid__item').removeClass("slideUp fadeOut").fadeIn(300);
	} else {
		$('.projects-list .grid__item').each(function () {			
			if (target !== 0 && $(this).data('type').toString().match(new RegExp("(?:^|,)"+target+"(?:,|$)"))) {
				$(this).removeClass("slideUp fadeOut").fadeIn(300);
			} else {
				$(this).css('display', 'none');
			}
		});
	}

	$('.no-touch .grid__item:visible').each(function () {
		var $element = $(this);
		$element.waypoint(
			function (direction) {
				if (direction === "down") {
					itemQueue.push(this.element);
					processWaypointsQueue();
				}
			}, {
				offset: function () {
					return $(window).height() - this.element.clientHeight / 5;
				}
			}
		);

		$element.waypoint(
			function (direction) {
				if (direction === "up") {
					$(this.element).removeClass("slideUp").addClass("fadeOut");
				}
			}, {
				offset: function () {
					return $(window).height() - this.element.clientHeight / 5;
				}
			}
		);

	});
}
function more(target, $e) {
	"use strict";

	var next_page = Number($('form[name="' + target + '-nav"] input[name="page"]').val()) + 1;
	$('form[name="' + target + '-nav"] input[name="page"]').val(next_page);
	$('.more-results[rel="' + target + '"]').addClass('disabled');

	$.ajax({
		data: $('form[name="' + target + '-nav"]').serialize(),
		dataType: 'html',
		success: function (data) {

			var $newItems = $(data);
			$('.' + target + '-list .grid').append($newItems);

			if (data.length === 0) {
				$e.fadeOut('fast');
				return;
			}

			Waypoint.destroyAll();

			$('.' + target + '-list .content .scroll-wrap').html('');
			$('.' + target + '-list .grid__item').each(function () {
				if ($(this).data('id') !== '') {
					var content = '<article class="content__item" data-id="' + $(this).data('id') + '"></article>';
					$('.' + target + '-list .content .scroll-wrap').append(content);
				}
			});

			$('.grid__item:visible').each(function () {
				var $element = $(this);
				$element.waypoint(
					function (direction) {
						if (direction === "down") {
							itemQueue.push(this.element);
							processWaypointsQueue();
						}
					}, {
						offset: function () {
							return $(window).height() - this.element.clientHeight / 5;
						}
					}
				);

				$element.waypoint(
					function (direction) {
						if (direction === "up") {
							$(this.element).removeClass("slideUp").addClass("fadeOut");
						}
					}, {
						offset: function () {
							return $(window).height() - this.element.clientHeight / 5;
						}
					}
				);

			});

			setTimeout(function () {
				$('.more-results[rel="' + target + '"]').removeClass('disabled');
			}, 500);
		}
	});
}
function initContactForm($params){
	'use strict';

	var contact_form = $('form[name="contact-form"]').validate({
		submitHandler: function() {

			$('form[name="contact-form"]').find('button[type="submit"]').attr('disabled','disabled');
			$.ajax({data:$('form[name="contact-form"]').serialize(), 
					success:function(data) {
						if(data.status === "ok"){

							

							$('form[name="contact-form"] input:text').val("");
							$('form[name="contact-form"] select').val("");
							$('form[name="contact-form"] textarea').val("");
							$('form[name="contact-form"] input[type="checkbox"]').prop('checked',false);
							$('form[name="contact-form"] input[type="radio"]').prop('checked',false);
							$('form[name="contact-form"]').find('.open-tab').removeClass('open-tab');
							$('form[name="contact-form"]').find('.show-tab').removeClass('show-tab');
							form_submit_response('form[name="contact-form"]','success',data.message);
							$('form[name="contact-form"]').find('button[type="submit"]').removeAttr('disabled');

							if(typeof($params.ga_submit_params)!=='undefined' ){
								registerGAEvent('form_submit', $params.ga_submit_params );
							}else{
								registerGAEvent('form_submit', {'event_category':"contact_form",'event_label':"Contact form submitted"} );
							}
					
						}else if(data.status === 'error') {
							$('form[name="contact-form"]').find('button[type="submit"]').removeAttr('disabled');
							form_submit_response('form[name="contact-form"]','error',data.error);
						}else{
							$('form[name="contact-form"]').find('button[type="submit"]').removeAttr('disabled');
							form_submit_response('form[name="contact-form"]','error','An unknown error occured. Please try again later');
						}
					}
			});
			return false;
		},
		rules: {
			fname		: "required",
			lname		: "required",
			message		: "required",
			email		: {
				required: true,
				email: true
			}
		},		 
		highlight: function (element, errorClass, validClass) {
			$(element).parent().find('.form-control-feedback').remove();
			$(element).closest('.form-group').append('<span class=" form-control-feedback"></span>');
			$(element).parent().addClass('has-error has-feedback');
        },
        unhighlight: function (element, errorClass, validClass) {
            $(element).parent().find('.form-control-feedback').remove();
            $(element).parent().removeClass('has-error has-feedback');
        },
		messages:{
			fname		: "We need to call you something... :)",
			lname		: "Need this to set you apart from the crowd..",
			email		: "Please enter a valid email",
			message		: "You must have something to say...."
		},
		errorPlacement: function(error, element) {
			element.parent().find('.form-control-feedback').html(error);
		}
	});
	$('.close-contact').click(function(){
		$('.has-error.has-feedback').each(function(){
			$(this).removeClass('has-feedback').removeClass('has-error');
		});
		contact_form.resetForm();	
	});
}
function form_submit_response(target,type,message,r){
	"use strict";
	var redirect = r || false;
	var markup = '';
	$('.alert').remove();
	
	if(type==="error"){
		markup = '<div class="alert alert-error text-center"><button type="button" class="close" data-dismiss="alert">&times;</button><b>'+message+'<b></div>';
	}else if(type === 'success'){
		markup = '<div class="alert alert-success text-center"><button type="button" class="close" data-dismiss="alert">&times;</button><b>'+message+'<b></div>';
		if(type === 'success' && redirect){
			setTimeout(function(){window.location.reload();},5000);
		}
	}else{
	}
	$(target).closest('form').prepend(markup);
}



function initializeMap() {
	"use strict";
	if (gmap_ready && $('#map_canvas').html() === '') {
		var myLatLon = new google.maps.LatLng(38.019613, 23.807184);
		var myOptions = {
			zoom: 13,
			panControl: true,
			zoomControl: true,
			scaleControl: true,
			streetViewControl: false,
			center: myLatLon,
			mapTypeId: google.maps.MapTypeId.ROADMAP
		};

		var map = new google.maps.Map(document.getElementById("map_canvas"), myOptions);

		var marker = new google.maps.Marker({
			position: myLatLon,
			animation: google.maps.Animation.DROP,
			map: map,
			title: "The Smiling Hippo Headquarters"
		});
	} else {
		gmap_ready = true;
	}
}
function notify(text) {
	"use strict";

	var $notification = $('<li />').text(text).css({
		left: 320
	});

	$notifications.append($notification);

	$notification.animate({
		left: 0
	}, 300, function () {
		$(this).delay(3000).animate({
			left: 320
		}, 200, function () {
			$(this).slideUp(100, function () {
				$(this).remove();
			});
		});
	});
}



function registerGAEvent($event,$params){
    "use strict";
      console.log('initiated');
    if(typeof(gtag)!=='undefined' && typeof($event)!=='undefined' && typeof($params)!=='undefined' ){
        console.log($event,$params,'success');
        gtag( 'event', $event , $params);
    }
}